export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["विवाद खोलें"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रद्द करें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["भेजें"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सहायता के लिए एक मॉडरेटर शामिल होगा। कृपया एक कारण चुनें और सबूत संलग्न करें।"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मॉडरेटर को भेजें"])}
}